<template>
	<div class="horizontal-menu">
		<ul class="list-unstyled nav">
			<li class="nav-item">
				<a href="javascript:void(0);" class="nav-link" >
					<i class="zmdi zmdi-view-dashboard"></i>
					<span class="menu-title">{{$t("message.general")}}</span>
				</a>
				<ul class="sub-menu list-unstyled">
					<template v-for="item in category1">
						<app-menu-item 
						:menu="item"
						:key="item.title"
						></app-menu-item>
					</template>
        		</ul>
     	 	</li>
      	<li class="nav-item">
				<a href="javascript:void(0);" class="nav-link">
					<i class="zmdi zmdi-widgets"></i>
					<span class="menu-title">{{$t("message.modules")}}</span>
				</a>
				<ul class="sub-menu list-unstyled">
					<template v-for="item in category2">
						<app-menu-item :menu="item" :key="item.title">
						</app-menu-item>
					</template>
				</ul>
      	</li>
			<li class="nav-item">
				<a href="javascript:void(0);" class="nav-link">
					<i class="zmdi zmdi-view-carousel"></i>
					<span class="menu-title">{{$t("message.components")}}</span>
				</a>
        		<ul class="sub-menu list-unstyled">
					<template v-for="item in category3">
						<app-menu-item :menu="item" :key="item.title">
						</app-menu-item>
					</template>
        		</ul>
      	</li> 
      	<li class="nav-item">
				<a href="javascript:void(0);" class="nav-link">
					<i class="zmdi zmdi-assignment-check"></i>
					<span class="menu-title">{{$t("message.applications")}}</span>
				</a>
        		<ul class="sub-menu list-unstyled">
					<template v-for="item in category4">
						<app-menu-item :menu="item" :key="item.title">
						</app-menu-item>
					</template>
        		</ul>
      	</li>
			<li class="nav-item">
				<a href="javascript:void(0);" class="nav-link">
					<i class="zmdi zmdi-wrench"></i>
					<span class="menu-title">{{$t("message.features")}}</span>
				</a>
				<ul class="sub-menu list-unstyled">
					<template v-for="item in category5">
						<app-menu-item :menu="item" :key="item.title">
						</app-menu-item>
					</template>
        		</ul>
      	</li>
    	</ul>
		<div class="ham-menu-sm d-none">
			<v-btn flat icon class="my-1 mx-3" @click="toggleHorizontalLayoutSidebar">
				<v-icon class="grey--text">menu</v-icon>
			</v-btn>
		</div>
		<div class="search-form">
			<v-text-field flat solo prepend-icon="search" :placeholder="$t('message.search')" class="search-bar "></v-text-field>
			<div class="mobile-search d-none">
				<v-btn flat small icon class="mobile-search-btn my-1 mx-3">
					<v-icon class="grey--text font-md">search</v-icon>
				</v-btn>
			</div>
		</div>
  	</div>
</template>

<script>
import $ from "jquery";
import {
  category1,
  category2,
  category3,
  category4,
  category5
} from "./AppLinks";
import AppMenuItem from "./AppMenuItem";
export default {
  components: {
    AppMenuItem
  },
  data() {
    return {
      category1,
      category2,
      category3,
      category4,
      category5
    };
  },
  methods: {
    toggleHorizontalLayoutSidebar() {
      this.$store.dispatch("toggleHorizontalLayoutSidebar", true);
    }
  },
  mounted() {
    $(".horizontal-menu .nav > .nav-item")
      .children()
      .click(function(e) {
        $(this)
          .parent()
          .addClass("nav-item-active");
        if (
          $(".horizontal-menu .nav > .nav-item").hasClass("nav-item-active")
        ) {
          $(".horizontal-menu .nav > .nav-item").removeClass("nav-item-active");
          $(this)
            .parent()
            .addClass("nav-item-active");
        }
      });
    $(".horizontal-menu .nav .nav-item .active")
      .parents(".horizontal-menu .nav > .nav-item")
      .addClass("nav-item-active");
  }
};
</script>